export const APPLE_STORE_LINK =
	'https://apps.apple.com/app/deezer-for-creators/id1502424629';
export const GOOGLE_PLAY_LINK =
	'https://play.google.com/store/apps/details?id=com.deezer.analytics';
export const FACEBOOK_LINK = 'https://www.facebook.com/deezerfr';
export const TWITTER_LINK = 'https://twitter.com/Deezer';
export const YOUTUBE_LINK = 'https://www.youtube.com/deezer';
export const INSTAGRAM_LINK = 'https://www.instagram.com/deezer/';

// START USEFUL LINKS
export const DOWNLOAD_APP_LINK = 'https://www.deezer.com/explore/download/';
export const OFFER_LINK = 'https://www.deezer.com/offers';
export const DISCOUNT_LINK = 'https://www.deezer.com/offers/discount';
export const FEEDBACK_LINK = 'https://www.deezer.com/explore/reviews/';
export const GIFT_LINK = 'https://www.deezer.com/gift';
export const BUY_GIFT_LINK =
	'https://www.deezer.com/payment/go.php?id=1&gift=1&origin=footer-gift-card';
export const SUPPORT_LINK = 'https://support.deezer.com';
export const CONTACT_LINK = 'https://support.deezer.com/requests/new';

// END USEFUL LINKS

// START FEATURES LINKS

export const FEATURES_LINK = 'https://www.deezer.com/explore/features/';
export const FLOW_LINK = 'https://www.deezer.com/explore/features/flow/';
export const SONG_CATCHER_LINK =
	'https://www.deezer.com/explore/features/songcatcher/';

export const TRANSFER_PLAYLIST_LINK =
	'https://www.deezer.com/explore/features/transfer-playlist/';
export const LYRICS_LINK = 'https://www.deezer.com/explore/features/lyrics/';
export const OFFLINE_LINK = 'https://www.deezer.com/explore/features/offline/';
export const HIFI_LINK = 'https://www.deezer.com/explore/features/hifi/';
export const SHAKER_LINK = 'https://www.deezer.com/explore/features/shaker/';
export const MUSIC_QUIZ_LINK =
	'https://www.deezer.com/explore/features/music-quiz/';
export const DEVICES_LINK = 'https://www.deezer.com/explore/devices/';

// END FEATURES LINKS

// START LIVE THE MUSIC LINKS

export const EXPLORE_LINK = 'https://www.deezer.com/channels/explore';
export const CHARTS_LINK = 'https://www.deezer.com/channels/charts';
export const NEW_LINK = 'https://www.deezer.com/channels/new';
export const THE_BACKSTAGE_LINK = 'https://www.thebackstage-deezer.com/';
export const COMMUNITY_LINK = 'https://en.deezercommunity.com';
export const PURPLE_CLUB_LINK =
	'https://www.deezer.com/explore/features/purpleclub/';

// END LIVE THE MUSIC LINKS

// START ABOUT US LINKS

export const DEEZER_HOME_LINK = 'https://www.deezer.com/';
export const NEWS_ROOM_LINK = 'https://www.newsroom-deezer.com/';
export const ARTIST_REMUNERATION_LINK =
	'https://www.deezer.com/explore/artist-remuneration/';
export const DEEZER_FOR_CREATORS_LINK =
	'https://www.deezer.com/explore/deezer_for_creators/';
export const INVESTORS_LINK = 'https://www.deezer-investors.com/';
export const BRAND_PARTNERSHIP = 'https://www.deezer-brandpartnerships.com/';
export const JOBS_LINK = 'https://www.deezerjobs.com';

// END ABOUT US LINKS

// START LEGAL LINKS

export const LEGAL_LINK = 'https://www.deezer.com/legal/legal';
export const CGU_LINK = 'https://www.deezer.com/legal/cgu';
export const PERSONAL_DATA_LINK = 'https://www.deezer.com/legal/personal-datas';
export const OPEN_SOURCE_LINK = 'https://www.deezer.com/explore/licenses';
export const CONFIDENTIALITY_LINK = 'https://vdp.deezer.com/p/Welcome';

// END LEGAL LINKS
